import { computed } from 'vue';
import { useStore } from 'vuex';

import { DeliveryTermsData } from '@/composables/types';
import { createSessionStorage } from '@/services/storage/storage-service';

export const useDeliveryTermsStorage = (storeContext = null) => {
  // storeContext - вынужденная мера, чтобы использовать composable из старых плагинов

  const STORAGE_NAME = 'deliveryTerms';

  const store = storeContext || useStore();
  const sessionStorage = createSessionStorage();

  const deliveryTerms = computed<DeliveryTermsData>(() => store.getters['deliveryTerms/deliveryTerms']);

  const getDataFromStorage = () => sessionStorage?.getItem(STORAGE_NAME);

  const fetchDeliveryTerms = async ({ forceUpdate = false } = {}) => {
    const terms = getDataFromStorage();

    if (!terms || forceUpdate) {
      await store.dispatch('deliveryTerms/fetchDeliveryTerms');
      sessionStorage?.setItem(STORAGE_NAME, { ...deliveryTerms.value });
    } else {
      store.commit('deliveryTerms/setDeliveryTerms', { ...terms });
    }
  };

  return {
    deliveryTerms,
    fetchDeliveryTerms,
  };
};
